import { jsx as _jsx, jsxs as _jsxs } from "tsx-dom/jsx-runtime";
/**
 * @returns The HTMLElement containing the splash screen
 */
export function SplashScreen() {
    return (_jsxs("div", { id: "splash-screen", class: "hidden", children: [_jsx("img", { src: "/logo.png", class: "logo", alt: "Old School Realms" }), _jsx("svg", { xmlns: "http://www.w3.org/2000/svg", class: "loading-animation", viewBox: "0 0 66 66", children: _jsx("circle", { xmlns: "http://www.w3.org/2000/svg", class: "spinner", fill: "none", "stroke-width": "6", "stroke-linecap": "round", cx: "33", cy: "33", r: "30" }) }), _jsx("div", { class: "loadbar", children: _jsx("div", { class: "loadbar-inner" }) })] }));
}
